import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    borderRadius: 12,
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.2)",
    transition: "all 0.3s ease-in-out",
    fontFamily: "Montserrat, sans-serif",
    "& .MuiAlert-message": {
      fontSize: "0.95rem",
      fontWeight: 500,
      lineHeight: 1.6,
      letterSpacing: "0.2px",
    },
  },

  success: {
    backgroundColor: "rgba(76, 175, 80, 0.1)",
    color: "#4CAF50", 
    border: "1px solid rgba(76, 175, 80, 0.35)",
  },

  error: {
    backgroundColor: "rgba(244, 67, 54, 0.08)",
    color: "#F44336", 
    border: "1px solid rgba(244, 67, 54, 0.35)",
  },

  info: {
    backgroundColor: "rgba(33, 150, 243, 0.08)",
    color: "#2196F3",
    border: "1px solid rgba(33, 150, 243, 0.35)",
  },
}));

export default useStyles;
